import styles from './about.module.css';
import Hero from './hero/hero';
import FullHero from './hero/fullHero';
import MediumHero from './hero/mediumHero';
import SignupButton from './signupbutton/signupbutton';
import Vision from './vision/vision';

const About = () => {
    return (
        <div className={styles.aboutContainer}>
            <MediumHero 
                imageUrl="https://images.unsplash.com/photo-1763041821558-71301407ded8" 
                altText="bakgrundsmynd"
            />
            <h2>Um felagið</h2>
            <p>Felagið arbeiðir fyri at skapa betri umstøður fyri súkklarar og gangandi í Havnini. Tað gera vit við at arbeiða saman við kommununi, stovnum, feløgum og skipa fyri tiltøkum fyri havnaborgarar.</p>
            <Vision />

            <h2>Nevnd</h2>
            <div className={styles.boardContainer}>
                
                <div className={styles.boardMember}>
                    <div className={styles.boardImage}>
                        <img src="https://www.gsah.unibe.ch/unibe/portal/fak_historisch/fsuf/iash/content/e343614/e343616/e284445/e998635/gsah_ics_doktorierende_gij_eng.jpg" alt="Guðrun í Jákupsstovu" />
                    </div>
                    <h5>Guðrun í Jákupsstovu</h5>
                    <p>Forkvinna</p>
                </div>
                <div className={styles.boardMember}>
                    <div className={styles.boardImage}>
                        <img src="https://styr.fo/wp-content/uploads/2021/08/styr-starvsfolk-2022_0009_Roi-Skardenni.jpg" alt="Rói Skarðenni" />
                    </div>
                    <h5>Rói Skarðenni</h5>
                    <p>Formaður</p>
                </div>
                <div className={styles.boardMember}>
                    <div className={styles.boardImage}>
                        <img src="https://scontent.ffae1-1.fna.fbcdn.net/v/t39.30808-6/464852387_8564837243564041_1544667571796634296_n.png?stp=dst-jpg_tt6&_nc_cat=100&ccb=1-7&_nc_sid=a5f93a&_nc_ohc=D0dN3rVsF5UQ7kNvwEJtztk&_nc_oc=Adly9P2NwDP2dx1GBOls6EG6OVOElkYmII7kiG-oSk780eWWzr9rdj4IU-O9Qfym7Z8&_nc_zt=23&_nc_ht=scontent.ffae1-1.fna&_nc_gid=AM_9F6ONzhRP1xsC3VYpcw&oh=00_Afg9o9ShM1LcwL2BYR4UpSwC6MZmaBxJgcBTNyFW4tJ4uw&oe=691EE25B" alt="Gunvør Balle" />
                    </div>
                    <h5>Gunvør Balle</h5>
                    <p>Nevndarlimur</p>
                </div>
                <div className={styles.boardMember}>
                    <div className={styles.boardImage}>
                        <img src="https://hotelforoyar.fo/admin/public/getimage.ashx?image=/Files/Images/starvsf%C3%B3lk/Sjurdur.jpg&format=webp&quality=75&width=1000" alt="Sjúrður Horsdal" />
                    </div>
                    <h5>Sjúrður Horsdal</h5>
                    <p>Nevndarlimur</p>
                </div>
                
            </div>
        </div>
    );
};

export default About;
